import requiredImg from "../Images/sp.gif";

const TextAreaField = (props) => {
  const AlterTextField = (e) => {
    props.ReceivedTextData({
      ...props.State,
      fieldName: e.target.name,
      fieldValue: e.target.value,
      event: e,
    });
  };

  const ClickTextArea = (e) => {
    // common.headerSearch = false;
  };

  let textForTextArea =
    props.value != null ? props.value.replace(/<br\s*\/?>/gi, "\n") : "";
  textForTextArea =
    textForTextArea != null ? textForTextArea.replace(/&gt;\s*\/?/gi, ">") : "";
  textForTextArea =
    textForTextArea != null ? textForTextArea.replace(/&lt;\s*\/?/gi, "<") : "";

  return (
    <>
      {props.label !== false && props.redMark === true ? (
        <label
          className={` ${
            props.labelClass !== "" ? props.labelClass : ""
          } mb-3 font-medium`}
        >
          {props.label}{" "}
          <img alt="Required" src={requiredImg} className="redboxRequired" />
        </label>
      ) : (
        <label
          className={`${
            props.labelClass !== "" ? props.labelClass : ""
          } mb-1 font-medium`}
        >
          {props.label}
        </label>
      )}
      <textarea
        className={
          props.width === true ? "w-full text-left field-input mt-3" : ""
        }
        value={textForTextArea}
        disabled={props.disabled ? props.disabled : false}
        rows={props.rows}
        cols={props.cols}
        name={props.id}
        onClick={props.click === true ? (e) => ClickTextArea(e) : null}
        maxLength={props.length ? props.length : 2000}
        onChange={(e) => AlterTextField(e)}
       />

      {props.requiredMsg != false ? (
        <label className="requiredFld requiredtext">
          {props.requiredMsg === true ? "Required" : props.requiredMsg}{" "}
        </label>
      ) : (
        ""
      )}
    </>
  );
};

export default TextAreaField;
